import { render, staticRenderFns } from "./ProcessReviewPage.vue?vue&type=template&id=29bbcee1"
import script from "./ProcessReviewPage.vue?vue&type=script&lang=js"
export * from "./ProcessReviewPage.vue?vue&type=script&lang=js"
import style0 from "./ProcessReviewPage.vue?vue&type=style&index=0&id=29bbcee1&prod&lang=less"
import style1 from "./ProcessReviewPage.vue?vue&type=style&index=1&id=29bbcee1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports